import React, { use, useState } from 'react';
import { DateTime } from 'luxon';
import { useSelector, useDispatch } from 'react-redux';
import { getDateShowingInActions, updateDateShowingInActions } from '@soulhx/client-store';
import { SHXButton, SHXCol, StandardButton } from '@soulhx/ui-common';
import { Modal } from 'react-bootstrap';
import { ActionWidgetForm } from './ActionWidgetForm.js';
import { CalendarView } from './CalendarView.js';
import { useTranslation } from 'react-i18next';
import { SoulHXContext, type SoulHXContextType } from '../../stores/SoulHXContext.js';
import { ShxHelpText } from '../common/ShxHelpText.js';

interface IActionsWidget {
  showTitle?: boolean;
  showDetails?: boolean;
  showLongNames?: boolean;
}
export const ActionsWidget = ({ showTitle = false, showDetails = true, showLongNames = true }: IActionsWidget) => {
  const dateToShow = DateTime.fromISO(useSelector(getDateShowingInActions));
  const dispatch = useDispatch();
  const { user } = use(SoulHXContext) as SoulHXContextType;
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  const { t } = useTranslation(['do']);

  const signupDate = DateTime.fromISO(user.signupDate);
  const showPrevButton = dateToShow.diff(signupDate, 'days').days > 0;
  const showNextButton = dateToShow.diff(DateTime.now(), 'days').days < -1;

  return (
    <SHXCol grow={1} minWidth="300px">
      {showTitle && <ShxHelpText pageName="home" textName="actionsWidget" className="mb-1" />}
      {!showTitle && <ShxHelpText pageName="do" textName="actionsWidget" className="mb-1" />}

      {showTitle && <h5 className="text-center">{t('do:actionsWidget.title')}</h5>}

      {showDetails && (
        <h5 className="d-flex justify-content-center">
          <StandardButton
            type="left"
            onClick={() => {
              const newDate = dateToShow.minus({ day: 1 });
              dispatch(updateDateShowingInActions(newDate.toISO()!));
            }}
            disabled={!showPrevButton}
            className="p-0"
          />

          <SHXButton variant="outline-dark" className="user-selecct-none p-0" onClick={() => setShowDatePicker(true)}>
            {dateToShow.toLocaleString()}
          </SHXButton>

          <StandardButton
            type="right"
            onClick={() => {
              const newDate = dateToShow.plus({ day: 1 });
              dispatch(updateDateShowingInActions(newDate.toISO()!));
            }}
            disabled={!showNextButton}
            className="p-0"
          />
        </h5>
      )}
      <ActionWidgetForm
        date={showDetails ? dateToShow : DateTime.now()}
        showDetails={showDetails}
        showLongNames={showLongNames}
      />

      <Modal
        show={showDatePicker}
        onHide={() => {
          setShowDatePicker(false);
        }}
      >
        <Modal.Header closeButton>{t('do:actionsWidget.datePickerTitle')}</Modal.Header>
        <Modal.Body>
          <CalendarView close={() => setShowDatePicker(false)} />
        </Modal.Body>
      </Modal>
    </SHXCol>
  );
};
